import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LicenseComponent } from './pages/license/license.component';
import { FreeLicenseComponent } from './pages/freelicense/free-license.component';
import { FreeBatchComponent } from './pages/freebatch/free-batch.component';
import { VOMComponent } from './pages/vom/vom.component';
import { GeneratefileComponent } from './pages/generatefile/generatefile.component';


const routes: Routes = [{
  path: '',
  component: LicenseComponent,
},
{
  path: 'free',
  component: FreeLicenseComponent
},
{
  path: 'free-batch',
  component: FreeBatchComponent
},
{
  path: 'vision-object-metadata',
  component: VOMComponent
},
{
  path: 'generatefile',
  component: GeneratefileComponent
}];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
